import { useEffect, useState } from "react";
import { fetchVendorInvoiceApprovalData, sendVendorInvoiceApprovalRequest } from "../Api/VendorInvoiceApproval";
import { Container, Table, Button } from "react-bootstrap";
import { toast } from "react-toastify";
//import "../Styling/VendorInvoiceApproval.css";

const VendorInvoiceApproval = () => {
  const [invoices, setInvoices] = useState([]);
  const userId = localStorage.getItem("userId"); 

  useEffect(() => {
    const loadInvoices = async () => {
      try {
        const data = await fetchVendorInvoiceApprovalData();
        setInvoices(data || []);
      } catch (error) {
        toast.error("🦄 Error Fetching Vendor Invoice Approval Data");
      }
    };
    loadInvoices();
  }, []);

  const handleApprove = async (invoiceId) => {
    try {
      await sendVendorInvoiceApprovalRequest(invoiceId, userId);
      toast.success(`🟢 Invoice ${invoiceId} Approved!`);
      setTimeout(() => window.location.reload(), 1000);
    } catch (error) {
      toast.error("❌ Error Sending Invoice Approval Request");
    }
  };

  return (
      <div className="main-content expand">
        <Container fluid className="list-container">
          <span className="list-title">Vendor Invoice Approval</span>

          {invoices.length > 0 ? (
            <div className="table-wrapper">
              <div className="table-scroll-container">
                <Table bordered hover className="data-table">
                  <thead>
                    <tr>
                      <th>#</th>
                      <th>Invoice ID</th>
                      <th>Company Code</th>
                      <th>Transaction Type</th>
                      <th>Category</th>
                      <th>Project Code</th>
                      <th>Invoice Number</th>
                      <th>Purchase Order</th>
                      <th>Invoice Date</th>
                      <th>Matrix ID</th>
                      <th>Approval Level</th>
                      <th>Status</th>
                      <th>Approved On</th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    {invoices.map((invoice, index) => (
                      <tr key={index}>
                        <td>{index + 1}</td>
                        <td>{invoice.invoiceId}</td>
                        <td>{invoice.companyCode}</td>
                        <td>{invoice.transactionType}</td>
                        <td>{invoice.category}</td>
                        <td>{invoice.projectCode}</td>
                        <td>{invoice.invoiceNumber}</td>
                        <td>{invoice.purchaseOrder}</td>
                        <td>{new Date(invoice.invoiceDate).toLocaleDateString()}</td>
                        <td>{invoice.matrixId}</td>
                        <td>{invoice.approvalLevel}</td>
                        <td className={invoice.approvalStatus === "W" ? "status-waiting" : "status-approved"}>
                          {invoice.approvalStatus === "W" ? "Waiting" : "Approved"}
                        </td>
                        <td>{invoice.approvedOn ? new Date(invoice.approvedOn).toLocaleString() : "-"}</td>
                        <td>
                          {invoice.approvalStatus === "W" && (
                            <Button
                              variant="primary"
                              size="sm"
                              onClick={() => handleApprove(invoice.invoiceId)}
                              className="approve-btn"
                            >
                              Approve
                            </Button>
                          )}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </Table>
              </div>
            </div>
          ) : (
            <p className="no-data">No vendor invoice approval requests found.</p>
          )}
        </Container>
      </div>
  );
};

export default VendorInvoiceApproval;